<!-- 预付款申请数据操作 -->
<template>
    <div>
        <subComponents ref="showSelectData"></subComponents>
        <purchaseOrderTemplate ref="purchaseOrderTemplate"></purchaseOrderTemplate>

        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
                        :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="(val) => { mxHeight = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form label-width="120px" id="mainInfo" class="baseForm" :model="sendDataInfo"
                                        disabled ref="sendDataInfo" size="mini" :show-message="false">
                                        <el-row slot="" v-if="dataActionBox.actionType != 2">
                                            <el-form-item v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                                v-if="formOneValue.isShow == 1" :key="formOneKey"
                                                :label="formOneValue.showField" :prop="formOneValue.entityField"
                                                :rules="formOneValue.isRequired == 1 ? [{ required: formOneValue.isChange == 1, trigger: ['blur', 'change'] }] : []">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                                    v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                <el-input v-if="formOneValue.fieldType == 'search'" clearable
                                                    v-model="sendDataInfo[formOneValue.entityField]"
                                                    :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                    @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                    :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1">
                                                    <el-button
                                                        @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                        slot="append" icon="el-icon-search"
                                                        :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1">
                                                    </el-button>
                                                </el-input>
                                                <df-date v-else-if="formOneValue.fieldType == 'date'"
                                                    @keyup.enter.native="nextFocus(formOneKey)" :isShowLong="false"
                                                    :isdisabled="formOneValue.isChange == 0"
                                                    v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                                <el-input type="number"
                                                    v-else-if="formOneValue.entityField == 'saiTelnumber' || formOneValue.entityField == 'saiPostcode'"
                                                    :disabled="formOneValue.isChange == 0"
                                                    @keyup.enter.native="nextFocus(formOneKey)"
                                                    v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                                <el-input v-else :disabled="formOneValue.isChange == 0"
                                                    @keyup.enter.native="nextFocus(formOneKey)"
                                                    v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                            </el-form-item>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <el-form-item :label="formOneValue.showField + ':'"
                                                :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1"
                                                v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                                :key="formOneKey">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                                    v-html="$common.htmlLabel(formOneValue.showField)+':'"></label>
                                                <span v-if="formOneValue.fieldType == 'date'">
                                                    {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField])
                                                    }}</span>
                                                <span v-else-if="formOneValue.isRift == 1">
                                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                                        sendDataInfo[formOneValue.entityField] }}</a>
                                                </span>
                                                <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>
                                    <!-- 明细操作 -->
                                    <el-form :inline="true" size="mini">
                                        <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                                            <el-button type="primary" size="mini" @click="addDetail('sendDataInfo')">
                                                新增明细</el-button>
                                            <el-button type="primary" size="mini" @click="deleteDetails()"
                                                :disabled="sendDataInfo.recallregisterInfoList.length < 1">删除明细
                                            </el-button>
                                        </div>
                                    </el-form>
                                    <!-- 明细信息 -->
                                    <el-table class="baseTable" v-if="mxForm" ref="mxTableRef"
                                        :data="sendDataInfo.recallregisterInfoList" border size="mini" :height="mxHeight">
                                        <el-table-column align="center" width="80" label="选择" v-if="dataActionBox.actionType != 2">
                                            <template slot-scope="scope">
                                                <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border
                                                    size="mini">
                                                    <i class="el-icon-thumb"></i>
                                                </el-radio>
                                            </template>
                                        </el-table-column>
                                        <el-table-column align="center" :prop="formOneValue.entityField" :label="formOneValue.showField"
                                            v-for="(formOneValue, formOneKey) in mxForm" :key="formOneKey"
                                            v-if="formOneValue.isShow == 1" :min-width="formOneValue.fieldWeight"
                                            show-overflow-tooltip>
                                            <template slot-scope="scope">
                                                <el-input
                                                    v-if="formOneValue.fieldType == 'search' && dataActionBox.actionType != 2"
                                                    clearable
                                                    v-model="sendDataInfo.recallregisterInfoList[scope.$index][formOneValue.entityField]"
                                                    @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField)">
                                                    <el-button
                                                        @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField)"
                                                        slot="append" icon="el-icon-search"></el-button>
                                                </el-input>
                                                <!-- 生产日期 -->
                                                <span v-else-if="formOneValue.fieldType == 'date'">
                                                    <span
                                                        v-if="sendDataInfo.recallregisterInfoList[scope.$index][formOneValue.entityField]">
                                                        {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                                    </span>
                                                </span>
                                                <span
                                                    v-else-if="formOneValue.entityField == 'rrmRrcus' && dataActionBox.actionType == 2">
                                                    {{ sendDataInfo.recallregisterInfoList[scope.$index].rrmRname }}
                                                </span>
                                                <el-input
                                                    v-else-if="formOneValue.entityField == 'rrmThisnumber' && dataActionBox.actionType != 2"
                                                    :disabled="formOneValue.isChange == 0"
                                                    @keyup.enter.native="nextFocus(formOneKey)" type="number"
                                                    v-model.trim="sendDataInfo.recallregisterInfoList[scope.$index][formOneValue.entityField]"></el-input>
                                                <span v-else>{{
                                                    sendDataInfo.recallregisterInfoList[scope.$index][formOneValue.entityField]
                                                }}</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foot">
                    <div>
                        <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary"
                            @click="showPrintPlan">打印
                        </el-button>
                        <el-button type="primary" @click="initActionBox('sendDataInfo')"
                            v-if="dataActionBox.actionType != 2">取消</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                            v-if="dataActionBox.actionType == 0">保存</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                            v-if="dataActionBox.actionType == 1">确定</el-button>
                    </div>
                </div>
            </div>

        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
            :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
                @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
    name: "recallRegistrationAction",
    props: ['actionData'],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            selectedDetailsIndex: 0,
            sendDataInfo: {
                bgmId: "",
                bgmName: "",
                rnmBatnumber: "",
                rnmNumber: 0,
                rnmReason: "",
                recallregisterInfoList: []
            },
            showTabs: "",
            formDataList: [],
            userOneList: [],
            seId: "",
            seWidth: "",
            height: "",
            seTitle: "",
            seWidth: "",
            DialogVisible: false,
            seType: "",
            smId: "",
            parentSearchData: {
                smId: "",
                bgsId: ""
            },
            tables: false,
            mxHeight: 0,
            tabForm: [],
            mxForm: [],
            footForm: []
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.rrmThisnumber"() {
            if (this.sendDataInfo.rrmThisnumber > this.sendDataInfo.rrmOrnumber) {
                this.$message({
                    message: "本次召回数量不得大于原召回数量",
                    type: "error",
                });
            }
        },
    },
    //方法集合
    methods: {
        deleteDetails() {
            this.$confirm("确定删除该条数据吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.sendDataInfo.recallregisterInfoList.splice(this.seIndex, 1);
                    this.$message({
                        message: "删除成功",
                        type: "success",
                    });
                })
                .catch(() => { });
        },
        addDetail() {
            let newInfo = {}
            this.mxForm.forEach(item1 => {
                if (item1.fieldType == 'number') {
                    this.$set(newInfo, item1.entityField, 0)
                } else if (item1.fieldType == 'search' && item1.setField) {
                    var arr = item1.setField.split(',')
                    arr.forEach(item2 => {
                        this.$set(newInfo, item2, "")
                    })
                } else {
                    this.$set(newInfo, item1.entityField, "")
                }
            })
            this.$set(newInfo, "createTime", this.$moment().valueOf())
            this.$set(newInfo, "rrmOrnumber", this.sendDataInfo.rrmOrnumber)
            this.$set(newInfo, "bgmId", this.sendDataInfo.bgmId)
            this.$set(newInfo, "rnmId", this.sendDataInfo.rnmId)
            this.sendDataInfo.recallregisterInfoList.push(JSON.parse(JSON.stringify(newInfo)))
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById('mainInfo')
            if (el) this.inputel = el.getElementsByTagName('input')
        },
        // 输入框切换焦点
        nextFocus(index) {
            if (index >= (this.inputel.length - 1)) return
            var aindex = index + 1
            if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
                this.nextFocus(aindex)
                return
            }
            this.inputel[aindex].focus()
        },
        showPrintPlan() { // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData
                    .printJurId)
            } else {
                return
            }
        },
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2) this.$parent.$parent.toDetail(orderId)
            else this.$parent.$parent.$parent.toDetail(orderId)
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        //检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.parentSearchData[type] = this.sendDataInfo[type]
            this.parentSearchData.bgsId = this.sendDataInfo.bgsId
            console.log(this.parentSearchData, this.sendDataInfo)
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.sendDataInfo.recallregisterInfoList[this.seIndex][item] = val[item]
            })
        },
        changeInputModel(val) {
            console.log(val)
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                // this.sendDataInfo.recallregisterInfoList[this.seIndex].rrmRname = val.cmName;
                // this.sendDataInfo.recallregisterInfoList[this.seIndex].rrmRrcus = val.cmId;
                // this.$set(this.sendDataInfo.recallregisterInfoList[this.seIndex],'rrmRname',val.cmName)
                // this.$set(this.sendDataInfo.recallregisterInfoList[this.seIndex],'rrmRrcus',val.cmId)
                for (const key in val) {
                    if (val[key] != null && val[key] != undefined) {
                        // this.sendDataInfo.recallregisterInfoList[this.seIndex][key] = val[key]
                        this.$set(this.sendDataInfo.recallregisterInfoList[this.seIndex], key, val[key])
                    } else {
                        this.sendDataInfo.recallregisterInfoList[this.seIndex][key] = ''
                        // this.$set(this.sendDataInfo.recallregisterInfoList[this.seIndex],key,val[key])
                    }
                }
            }
        },

        initActionBox(sendDataInfo) {
            this.$confirm("确定取消" + this.dataActionBox.boxTitle + "吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.dataActionBox.actionType = 0;
                    this.$emit('drawerCancel')
                    this.tables = false;
                    this.init();
                    this.$refs[sendDataInfo].resetFields();
                })
                .catch(() => { });
        },
        init() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
            this.sendDataInfo.recallregisterInfoList = []
        },
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate
            this.formDataList = this.actionData.formData
            var oldData = this.actionData.oldData
            this.filterMainField()
            this.init();
            console.log(this.dataActionBox)
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增召回登记信息";
                this.dataActionBox.openMode = "ltr";
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "登记召回信息";
                this.dataActionBox.openMode = "rtl";
                for (let key in oldData) {
                    if (key != "recallregisterInfoList") {
                        this.sendDataInfo[key] = oldData[key];
                    }
                }
                console.log(this.sendDataInfo)
            } else {
                this.tables = true
                this.dataActionBox.boxTitle = '查看召回登记信息'
                var dataInfo = JSON.parse(JSON.stringify(oldData))
                for (let key in dataInfo) {
                    this.sendDataInfo[key] = dataInfo[key]
                }
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.mxHeight = this.$common.getHeight()
                    }
                }, 16.7)
            });
        },
        sendDataAction(sendDataInfo) {

            this.sub()
            // this.$refs[sendDataInfo][0].validate((valid) => {
            // 	if (valid) {
            // 		this.sub();
            // 	} else {
            // 		console.log("error submit!!");
            // 		return false;
            // 	}
            // });
        },
        async sub() {
            let allNum = 0
            this.sendDataInfo.recallregisterInfoList.forEach(item => {
                allNum += Number(item.rrmThisnumber)
            })
            console.log(allNum, this.sendDataInfo.rnmNumber)
            if (Number(allNum) > Number(this.sendDataInfo.rnmNumber)) {
                return this.$message({
                    message: "召回数量不能大于原召回数量",
                    type: "warning",
                });
            }
            let sendData = {
                list: JSON.parse(JSON.stringify(this.sendDataInfo.recallregisterInfoList))
            }
            if (this.dataActionBox.actionType == 0) {
                // 新增预付款
                var responseData = await this.$http.addRecallRegistration(sendData);
            } else {
                // 暂时没有编辑接口
                var responseData = await this.$http.addRecallRegistration(sendData);
            }
            if (responseData.status == 200) {
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit('drawerCancel', true)
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = []
            this.formDataList.forEach(item => {
                if (item.jciType == 1) {
                    mainFormList.push(item)
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
                }
            })
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key))
                this.tabForm[i].jurconfigform = []
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key
                        .jurconfigform[index])
                }
            })
            var arr = [{ entityField: "recallregisterInfoList" }]
            var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
            this.showTabs = this.tabForm[0].jciName
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox()
        })
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput()
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.el-drawer {
    outline: none;
}

.mb {
    margin-bottom: 0;
}

.newInput {
    height: 28px;
    line-height: 28px;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
}
</style>